import {
  Schedule,
  TimeOffQueryParams,
  TimeOffRequestListQueryParams,
  Uri,
} from '@nextforce/api'

const keys = {
  all: ['time_off_requests'],
  detail: (params: TimeOffQueryParams) => [...keys.all, params],
  crew: (uri: Uri) => [...keys.all, `?${uri}`],
  list: (
    schedule: Schedule | undefined,
    params?: TimeOffRequestListQueryParams
  ) => [...keys.all, params, schedule],
}

export default keys
